import script from "./accounts-group-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./accounts-group-card.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__